import types from "./types";

const INITIAL_STATE = {
  isFetchedAllRoles: false,
  allRolesList: [],
  isFetchedEntityUserRoles: false,
  entityUserRolesList: [],
  fetchingError: false,
  message: "",
};

const getMostRecentDate = (dateList) => {
  if (!Array.isArray(dateList) || dateList.length === 0) return null;

  return dateList.reduce((latest, current) => {
    const latestTime = new Date(latest).getTime();
    const currentTime = new Date(current).getTime();

    if (isNaN(latestTime)) return current;
    if (isNaN(currentTime)) return latest;

    return currentTime > latestTime ? current : latest;
  });
};

const formatDate = (isoString) => {
  if (!isoString) return "N/A";

  const d = new Date(isoString);
  if (isNaN(d.getTime())) return "N/A";

  const timeString = d.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
    timeZoneName: "short",
  });

  const [timePart, ampm, tz] = timeString.split(" ");

  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  const year = d.getFullYear();

  const result = `${month}/${day}/${year}, ${timePart} ${ampm} ${tz}`;
  return result.replace(/\b[a-z]{2,5}$/, (match) => match.toUpperCase());
};

const UserRoleManagementReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.ALL_ROLES_GET_REQUEST:
      return {
        ...state,
        isFetchedAllRoles: false,
        fetchingError: false,
        message: false,
      };

    case types.ALL_ROLES_GET_RECEIVE:
      return {
        ...state,
        isFetchedAllRoles: true,
        allRolesList: action.response.roles,
        fetchingError: false,
        message: false,
      };

    case types.ALL_ROLES_GET_ERROR:
      return {
        ...state,
        isFetchedAllRoles: false,
        fetchingError: "An error occurred while fetching all roles",
        message: false,
      };

    case types.ENTITY_USER_ROLES_GET_REQUEST:
      return {
        ...state,
        isFetchedEntityUserRoles: false,
        fetchingError: false,
        message: false,
      };

    case types.ENTITY_USER_ROLES_GET_RECEIVE: {
      const rawUserRoles = action.response.roles || [];

      const transformedUserRoles = rawUserRoles.map((user) => {
        const { userDetails, roles } = user;
        const fullName = `${userDetails.firstName} ${userDetails.lastName}`;
        const email = userDetails.userEmail;
        const firstOrg = roles.length > 0 ? roles[0].type : "N/A";
        const mostRecentLastUpdated = getMostRecentDate(roles.map((role) => role.lastUpdated));

        return {
          userId: user.userId.trim(),
          displayName: fullName,
          email,
          roleNames: roles.map((role) => role.name),
          roleIds: roles.map((role) => role.id),
          org: firstOrg,
          lastUpdated: formatDate(mostRecentLastUpdated),
        };
      });

      return {
        ...state,
        isFetchedEntityUserRoles: true,
        entityUserRolesList: transformedUserRoles,
        fetchingError: false,
        message: false,
      };
    }

    case types.ENTITY_USER_ROLES_GET_ERROR:
      return {
        ...state,
        isFetchedEntityUserRoles: false,
        fetchingError: "An error occurred while fetching entity user roles",
        message: false,
      };

    default:
      return state;
  }
};

export default UserRoleManagementReducer;
